/**
 * Validate whether a construction site has all required fields filled.
 * Used by both ConstructionTable (for "Send" button visibility)
 * and ConstructionForm (for auto-sending on save by admin/approver).
 *
 * @param {Object} siteData - The site data object (rowData from table or form data)
 * @returns {boolean} - true if all required fields are filled
 */
export const isSiteConstructionComplete = (siteData) => {
	if (!siteData) return false;

	const baseFieldsComplete =
		siteData.GPS !== null &&
		siteData.SF_id !== null &&
		siteData.address !== null &&
		siteData.city !== null &&
		siteData.cod !== null &&
		siteData.contract_id !== null &&
		siteData.contract_duration !== null &&
		siteData.country !== null &&
		siteData.nb_grid_meter !== null &&
		siteData.nb_amb_temp !== null &&
		siteData.site_name !== null &&
		siteData.solo !== null &&
		siteData.sync !== null &&
		siteData.temp_client_name !== null;

	if (!baseFieldsComplete) return false;

	// PV fields are required unless is_no_PV is true
	const pvFieldsComplete =
		(siteData.nb_irr_sensors !== null &&
			siteData.nb_inj_points !== null &&
			siteData.nb_inverter !== null &&
			siteData.inverter_id !== null &&
			siteData.EDMI_meter !== null &&
			siteData.nb_solar_modules !== null &&
			siteData.temp_solar_module !== null &&
			siteData.nb_mod_temp !== null &&
			siteData.power !== null) ||
		siteData.is_no_PV;

	if (!pvFieldsComplete) return false;

	// BESS fields are required if is_BESS is true
	if (siteData.is_BESS) {
		const bessFieldsComplete =
			siteData.BESS_capacity !== null &&
			siteData.BESS_model !== null &&
			siteData.BESS_nb_cabinets > 0 &&
			siteData.is_no_PV !== null &&
			siteData.BESS_meter_type !== null;

		if (!bessFieldsComplete) return false;
	}

	return true;
};
